import {Component, computed, inject} from '@angular/core';
import {SidenavComponent} from '../core/ui/sidnav/component';
import {SearchComponent} from '../core/ui/search/search.component';
import {Store} from '@ngxs/store';
import {DashboardState} from './+state/dashboard.state';
import {toSignal} from '@angular/core/rxjs-interop';
import {defaultState} from './+state/dashboard-state.model';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {NgClass} from '@angular/common';
import {MENU_SECTIONS_TOKEN} from '../core/constants/menu.constant';
import {NotificationsComponent} from '../notifications/notifications.component';

// animations
const showAnimation = state('show', style({
  opacity: 1,
}));
const hideAnimation = state('hide', style({
  opacity: 0,
  height: 0,
  width: 0,
  padding: 0,
}));

const showHideAnimations = (triggerName: string) => trigger(triggerName, [
  showAnimation, hideAnimation,
  transition('hide => show', [animate('0.1s')]),
  transition('show => hide', [animate('0.2s')])
])

@Component({
  selector: 'app-dashboard',
  template: `
    <div class="flex flex-col h-full w-full">
      <main class="flex flex-row-reverse h-full w-full">
        <div [ngClass]="showSideNav() ? 'md:max-w-[calc(100%-240px)]' : ''" class="divide flex-1">
          <header [@showHideHeader]="showHeader() ? 'show' : 'hide'" class="h-[64px] shadow-sm p-4 flex gap-4 items-center">
            <app-search></app-search>
            <app-notifications></app-notifications>
          </header>
          <div [ngClass]="{'full': !showHeader()}" class="content">
            <ng-content></ng-content>
          </div>
        </div>
        <app-sidenav [ngClass]="showSideNav() ? 'show' : 'hide'" [@showHideSidenav]="showSideNav() ? 'show' : 'hide'" [sections]="sections()"></app-sidenav>
      </main>
    </div>
  `,
  styles: `
    :host {
      display: block;
      width: 100%;
      height: 100vh;

      &.progress {
        height: calc(100vh - 4px);
      }
    }

    .content {
      height: calc(100vh - 64px);
      background-color: rgba(241, 242, 247, 0.57);
      &.full {
        height: 100vh;
      }
    }
  `,
  imports: [SidenavComponent, SearchComponent, NgClass, NotificationsComponent],
  animations: [
    showHideAnimations('showHideHeader'),
    showHideAnimations('showHideSidenav'),
  ],
})
export class DashboardComponent {
  readonly sections = inject(MENU_SECTIONS_TOKEN);
  private readonly state = toSignal(
    inject(Store).select(DashboardState.getStates),
    {
      initialValue: defaultState
    }
  );

  showHeader = computed(() => this.state()?.header ?? false);
  showSideNav = computed(() => this.state()?.sidenav ?? false);
}
